(function (){
    'use strict';


    var extDeps = [];
    var module = angular.module('app.common.widgets.commands',extDeps);




    module.directive('toggle', toggleDirective);
    toggleDirective.$inject=[];
    function toggleDirective(){
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                if(!attrs.toggle.match(/offcanvas/i))
                    return;

                element.on("click", function () {
                    if(attrs.target)
                        $(attrs.target).toggleClass("active");
                    else if(attrs.toggle.match(/right/i))
                        $(".row-offcanvas-right:first").toggleClass("active");
                    else
                        $(".row-offcanvas-left:first").toggleClass("active");
                });

            }
        };

    }


    module.directive('offcanvasRightCmd', offCanvasRightCmdDirective);
    offCanvasRightCmdDirective.$inject=['$timeout'];
    function offCanvasRightCmdDirective($timeout){
        return {
            restrict: 'E',
            scope:{ visible:'@'},
            link: function (scope) {

                $timeout(function(){
                    if((/true/i).test(scope.visible)){
                        $(".row-offcanvas-right:first").addClass("active");
                        $('#sidebarRight').show()
                    }else{
                        $(".row-offcanvas-right:first").removeClass("active");
                        $('#sidebarRight').fadeOut('slow').hide();
                    }

                },100);
            }
        };
    }


    module.directive('scrollIntoViewCmd', scrollIntoViewCmdDirective);
    scrollIntoViewCmdDirective.$inject=['$timeout'];
    function scrollIntoViewCmdDirective($timeout){
        return {
            restrict: 'E',
            scope: {
                onScrolled: '&'
            },
            link: function(scope,element,attr){

                scope.$on('scrollIntoView:' + attr.tag, function(){
                    _triggerScrollAnimation(element, attr, scope);
                });

                _triggerScrollAnimation(element, attr, scope);
            }
        };


        function _triggerScrollAnimation( element,attr, scope){

            var offset = parseInt(attr.offset ) || 0;
            $timeout(function(){
                var parent = attr.relativeTo ? $(attr.relativeTo) : $(document.body);
                var eleTop = element.offset().top + parent.scrollTop();
                var parTop = parent.offset().top;

                var val = element.attr('initialVal');
                if(!val){
                    val = eleTop - parTop -  offset;
                    element.attr('initialVal', val);
                }

               // console.log(element, parent, eleTop - parTop -  offset)
                parent.animate(
                    {scrollTop: val }
                    , {
                        duration: 'slow'
                        , complete: function () {
                            if (scope.onScrolled)
                                $timeout(function(){ scope.onScrolled(); },50)
                        }
                    });

            },50);


        }
    }

    module.directive('delayUntilInScrollWrapperViewCmd', delayUntilInScrollWrapperViewCmdDirective);
    delayUntilInScrollWrapperViewCmdDirective.$inject=['$q', '$timeout', 'debounce'];
    function delayUntilInScrollWrapperViewCmdDirective($q, $timeout, debounce){
        return {
            restrict: 'E',
            scope: {
                onVisible: '&'
            },
            link: function(scope,element,attr){

                var offset = parseInt(attr.offset ) || 10;
                waitUntilElementInView(element, offset)
                    .then(function(){
                        if(scope.onVisible)
                            $timeout(function(){  scope.onVisible(); },50);
                    });
            }
        };

        function waitUntilElementInView( element,offset){

            var def = $q.defer();
            var rt =  def.promise;

            var _resolveWhenInScrollViewFunc = (function(f){ return debounce(f, 50, false);})(resolveWhenInScrollViewFunc);

            var parent = element.parents('.scroll-wrapper');
            var scrollHandler = function (){
                _resolveWhenInScrollViewFunc(def,element, parent, offset);
            };
            parent.on('scroll', scrollHandler);
            rt.then(function () {
                parent.off('scroll', scrollHandler);
            });

            // Execute on load
            $timeout(scrollHandler,0);

            return rt;
        }

        function resolveWhenInScrollViewFunc(def, element,parent, offset){
            var eleTop = element.offset().top + parent.scrollTop();
            var parTop = parent.offset().top;
            var val = eleTop - parTop +  offset;
            var isInView = val < parent.scrollTop() + parent.height();
            if(isInView)
                def.resolve();
        }
    }


    module.directive('trackPageViewCmd',trackPageViewCmdDirective);
    trackPageViewCmdDirective.$inject=['$timeout', '$window'];
    function trackPageViewCmdDirective($timeout, $window){
        return {
            restrict: 'E'
            , link: linkFn
            , scope:{
                contentTitle:'@'
            }
        };

        function linkFn(scope){

            scope.$watch('contentTitle',function(nv,ov){
                if(nv !== ov)
                    triggerCommand(scope);
            });

            triggerCommand(scope);
        }

        function triggerCommand(scope){
            if(!$window.gtag)
                return;

            var pageUrl = document.location.href
                .replace(document.location.origin,'')
                .replace(/\d{4}-\d{2}-\d{2}\/?/,'')
                .replace(/notes\/\d+$/,'notes')
                .replace(/\?go=\d+/,'');

            var payload = {
                title : [document.title, scope.contentTitle].join(' - ')
                , page : pageUrl
            };
            $window.gtag('event', 'page_view', payload);
        }
    }



})();

